import React, { useCallback } from "react";
import PropTypes from "prop-types";
import styles from "./styles.module.scss";

const LayoutOption = ({ checked, onChange, label, value, green = false }) => {
  const id = `layout-${value}`;
  return (
    <>
      <input
        id={id}
        type="checkbox"
        value={value}
        checked={checked}
        className={styles.LayoutOption}
        onChange={({ currentTarget }) => onChange(value, currentTarget.checked)}
      />
      <label htmlFor={id} className={green ? styles.green : ""}>
        <svg className={`icon icon-layout-${value}`}>
          <use xlinkHref={`#icon-layout-${value}`} />
        </svg>
        <span>{label}</span>
      </label>
    </>
  );
};

LayoutOption.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  green: PropTypes.bool,
};

const options = [
  "Boardroom",
  "Classroom",
  "Cabaret",
  "Theatre",
  "Restaurant",
  "Open Space",
];

const LayoutOptions = ({ onChange, value = [], green = false }) => {
  const handleChange = useCallback(
    (val, checked) => {
      if (typeof onChange !== "function") return;
      const newValue = checked
        ? [...value, val]
        : value.filter((opt) => opt !== val);
      onChange(newValue);
    },
    [onChange, value]
  );

  return options.map((label) => {
    const labelValue = label.toLowerCase().replace(/ /g, "_");
    return (
      <LayoutOption
        key={labelValue}
        checked={value.includes(labelValue)}
        onChange={handleChange}
        value={labelValue}
        label={label}
        green={green}
      />
    );
  });
};

LayoutOptions.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  green: PropTypes.bool,
};

export default LayoutOptions;
